export interface NamingFinding {
  rule: string;
  message: string;
  suggestion: string | null;
}

export interface NamingTrendPoint {
  period: string;
  total: number;
  clear: number;
  pct_clear: number | null;
}

export interface NamingProjectScore {
  project_key: string;
  project_name: string | null;
  total: number;
  clear: number;
  attention: number;
  pct_clear: number | null;
  trend: NamingTrendPoint[];
}

export interface NamingSummary {
  period: string;
  months: string[];
  overall: { total: number; clear: number; attention: number; pct_clear: number | null };
  projects: NamingProjectScore[];
  top_rules: Array<{ rule: string; name: string | null; hits: number }>;
}

export interface NamingResultRow {
  issue_id: string;
  issue_key: string;
  issue_name: string | null;
  issue_type: string | null;
  project_key: string;
  status: string | null;
  created_at: string;
  assignee: { account_id: string; display_name: string | null } | null;
  reporter: { account_id: string; display_name: string | null } | null;
  verdict: 'clear' | 'attention';
  findings: NamingFinding[];
  evaluated_at: string;
  jira_url: string;
}

export const TYPE_BADGE: Record<string, string> = {
  epic: 'bg-violet-50 text-violet-700 ring-violet-200',
  story: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  task: 'bg-blue-50 text-blue-700 ring-blue-200',
  bug: 'bg-rose-50 text-rose-700 ring-rose-200',
  'sub-task': 'bg-sky-50 text-sky-700 ring-sky-200',
  subtask: 'bg-sky-50 text-sky-700 ring-sky-200',
  'custom subtask': 'bg-sky-50 text-sky-700 ring-sky-200',
  design: 'bg-pink-50 text-pink-700 ring-pink-200',
  devops: 'bg-indigo-50 text-indigo-700 ring-indigo-200',
  automation: 'bg-slate-50 text-slate-700 ring-slate-200',
};

export function typeBadge(type: string | null | undefined): string {
  return TYPE_BADGE[(type ?? '').toLowerCase()] ?? 'bg-gray-50 text-gray-600 ring-gray-200';
}

export function pctTone(pct: number | null): string {
  if (pct === null) return 'text-gray-500';
  if (pct >= 80) return 'text-emerald-700';
  if (pct >= 60) return 'text-amber-700';
  return 'text-rose-700';
}
